// extracted by mini-css-extract-plugin
module.exports = {"form":"vd__1y_X7","inputWithTooltip":"vd__gLELU","footer":"vd__37EE4"};